import { useQuery } from '@tanstack/react-query';

import { useAxios } from './useAxios';

export interface AgentSummary {
  name: string;
  title: string;
  description: string;
  nonPraetorian: boolean;
  // Hunt-eligibility metadata. Only set on capability-mode agents that
  // accept a `hunt` target; consumed by the New Hunt modal to filter
  // the list of root agents.
  capability?: boolean;
  target?: string[];
  tools?: string[];
  maxToolCalls?: number;
}

export const useAIAgents = () => {
  const axios = useAxios();

  return useQuery({
    queryKey: ['ai-agents'],
    queryFn: async () => {
      const response = await axios.get<AgentSummary[]>('/agents');
      return response.data;
    },
    staleTime: 300000, // 5min - agents rarely change
    gcTime: 600000, // 10min cache retention
  });
};
